import React from "react";

export default function AboutUsCards() {
    return (
        <section className="flat-spacing-3">
            <div className="container">
                <div className="flat-title-2 text-center">
                    <p className="display-md-2 fw-medium">Why Choose Lux & Co</p>
                    <p className="text-md text-main">
                        Each collection is a reflection of our commitment to craftsmanship and sustainable style. {" "}
                        <br className="d-none d-lg-block"/>From
                        concept to creation, every detail is thoughtfully considered to ensure that what you wear feels
                        as good as it looks.
                    </p>
                </div>
                <div className="row">
                    <div className="col-xl-7 col-md-6">
                        <ul className="list-esd d-md-flex flex-md-column justify-content-md-center h-100">
                            <li className="item">
                                <h6>Ethics &amp; Responsibility</h6>
                                <p className="text-md">
                                    At Lux & Co, integrity isn’t just a value — it’s a standard. We champion responsible
                                    production through transparent sourcing, continuous training, and routine audits,
                                    ensuring every piece reflects our ethical promise.
                                </p>
                            </li>
                            <li className="item">
                                <h6>Welcome to Lux and Co. Where fabric meets finesse.</h6>
                                <p className="text-md">
                                    From refined tailoring to elevated everyday essentials, Lux & Co fuses timeless
                                    design with a modern edge. Our collections are thoughtfully made for those who value
                                    both style and substance — wear after wear.
                                </p>
                            </li>
                            <li className="item">
                                <h6>Elegance, Woven in Every Thread.</h6>
                                <p className="text-md">
                                    Driven by creativity and grounded in trend-aware craftsmanship, our pieces empower
                                    self-expression for the modern generation. Lux & Co is where contemporary fashion
                                    meets comfort and confidence.
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <div className="image radius-16 overflow-hidden w-100 h-100">
                            <img
                                src="/images/logo/logo.jpg"
                                data-=""
                                alt=""
                                className="lazyload w-100 h-100 object-fit-cover"
                                width={586}
                                height={586}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
